import React from 'react'
import { useTranslation } from 'react-i18next'

import { NavItemAlt, NavItemVariant } from '@makyoapp/makyo-ui'

export interface HorizontalNavProps {
  /**
   * array/collections of routes that will be turned into menu
   */
  menu: {
    path?: string
    name: string
    index?: boolean
    showOnNav?: boolean
  }[]
  /**
   * @param path
   * function callback to pre-process the [to] params for `<NavLink>`
   * eq:
   * getTo={(path) => (path + '/' + id ) }
   */
  getTo: (path: string) => string
}

export function HorizontalMenu({ menu, getTo }: HorizontalNavProps) {
  const { t } = useTranslation()

  return (
    <nav className='mk-horz-menu'>
      {menu.map((route) => {
        if (route.showOnNav !== false) {
          return (
            <NavItemAlt
              end={route.index}
              variant={NavItemVariant.HorizWithLine}
              key={`setting-${route.path || 'index'}`}
              to={getTo(route.path || '')}
              text={t(route.name)}
              className='shrink-0'
            >
              {t(route.name)}
            </NavItemAlt>
          )
        } else {
          return null
        }
      })}
    </nav>
  )
}
